const APPLICANT_TYPES = {
  pending: "PENDING",
  withdrawn: "WITHDRAWN",
  applied: "APPLIED",
  selected: "SELECTED",
  unselected: "UNSELECTED",
  shortlisted: "SHORTLISTED",
  interviewed: "INTERVIEWED",
  recommended: "RECOMMENDED",
  invited: "INVITED",
};

const NOTIFIABLE_APPLICANT_TYPES = [APPLICANT_TYPES.shortlisted, APPLICANT_TYPES.unselected];

export default APPLICANT_TYPES;

export { NOTIFIABLE_APPLICANT_TYPES };
